/* ==========================================================================
   Trap Speed Horsepower Calculator
   Self-contained. Loaded only on this calculator's page.
   No shared dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-tsh]');
  if (!root) return;

  /* The classic Hale and Fox correlations for quarter mile performance.
     Trap speed reflects average power over the run and is far less sensitive
     to launch quality than elapsed time is. */
  var TRAP_K = 234;
  var ET_K   = 5.825;

  /* Typical driveline losses between crank and wheels. */
  var DRIVELINE_LOSS = { rwd: 0.15, fwd: 0.12, awd: 0.22 };

  /* ====================================================================
     compute(input) -> result

     PURE. No DOM, no network, no globals. All calculator logic lives here
     so it can be reasoned about and tested in isolation.
     ==================================================================== */
  function compute(input) {
    if (!isFinite(input.weight) || input.weight <= 0) {
      return { ok: false, errors: ['Enter the race weight including the driver.'] };
    }
    if (!isFinite(input.trap) || input.trap <= 0) {
      return { ok: false, errors: ['Enter the trap speed in miles per hour.'] };
    }

    var hpTrap = input.weight * Math.pow(input.trap / TRAP_K, 3);
    var loss = DRIVELINE_LOSS[input.drivetrain] || 0.15;
    var whp = hpTrap * (1 - loss);
    var ratio = input.weight / hpTrap;

    var figures = [
      { label: 'Estimated crank power', value: comma(Math.round(hpTrap)) + ' hp',
        sub: 'From ' + num(input.trap, 1) + ' mph at ' + comma(Math.round(input.weight)) + ' lb.' },
      { label: 'Roughly at the wheels', value: comma(Math.round(whp)) + ' whp',
        sub: 'Allowing ' + num(loss * 100, 0) + '% driveline loss for ' + input.drivetrain.toUpperCase() + '.' }
    ];

    var rows = [
      { head: 'From trap speed' },
      { label: 'Trap speed', value: num(input.trap, 1) + ' mph' },
      { label: 'Weight', value: comma(Math.round(input.weight)) + ' lb' },
      { label: 'Crank power', value: comma(Math.round(hpTrap)) + ' hp' },
      { label: 'Power to weight', value: num(ratio, 2) + ' lb/hp' }
    ];

    var status = { key: 'good', label: comma(Math.round(hpTrap)) + ' hp',
                   note: num(ratio, 1) + ' pounds per horsepower.' };
    var warnings = [];

    if (isFinite(input.et) && input.et > 0) {
      var hpEt = input.weight / Math.pow(input.et / ET_K, 3);
      var spread = ((hpEt - hpTrap) / hpTrap) * 100;
      rows.push({ head: 'From elapsed time' });
      rows.push({ label: 'ET', value: num(input.et, 2) + ' s' });
      rows.push({ label: 'Crank power', value: comma(Math.round(hpEt)) + ' hp' });
      rows.push({ label: 'Difference', value: signed(spread, 0) + '%' });

      figures.push({ label: 'ET method says', value: comma(Math.round(hpEt)) + ' hp',
        sub: signed(spread, 0) + '% against the trap speed figure.' });

      if (spread < -12) {
        warnings.push('The ET estimate is well below the trap speed estimate, which almost always means traction or a soft launch cost you time. Trust the trap speed number.');
      } else if (spread > 12) {
        warnings.push('The ET estimate is well above the trap speed estimate, which usually means an unusually good launch or a short shift near the traps.');
      }
    }

    rows.push({ head: 'For reference' });
    rows.push({ label: '13.0s / 105 mph', value: 'about ' + comma(Math.round(input.weight * Math.pow(105 / TRAP_K, 3))) + ' hp at this weight' });
    rows.push({ label: '12.0s / 115 mph', value: 'about ' + comma(Math.round(input.weight * Math.pow(115 / TRAP_K, 3))) + ' hp at this weight' });
    rows.push({ label: '11.0s / 125 mph', value: 'about ' + comma(Math.round(input.weight * Math.pow(125 / TRAP_K, 3))) + ' hp at this weight' });

    return { ok: true, errors: [], warnings: warnings, status: status, figures: figures, rows: rows };
  }

  /* ====================================================================
     Formatting
     ==================================================================== */
  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n, dp) {
    if (!isFinite(n)) return '-';
    var v = Number(n).toFixed(dp == null ? 2 : dp);
    if (dp !== 0 && v.indexOf('.') > -1) v = v.replace(/\.?0+$/, '');
    var parts = v.split('.');
    return comma(parts[0]) + (parts[1] ? '.' + parts[1] : '');
  }

  function signed(n, dp) {
    if (!isFinite(n)) return '-';
    return (n > 0 ? '+' : '') + num(n, dp);
  }

  /* ====================================================================
     DOM wiring
     ==================================================================== */
  var FIELDS = [
      {
          "name": "weight",
          "key": "w",
          "type": "number"
      },
      {
          "name": "trap",
          "key": "t",
          "type": "number"
      },
      {
          "name": "et",
          "key": "e",
          "type": "number"
      },
      {
          "name": "drivetrain",
          "key": "d",
          "type": "select"
      }
  ];

  var els = {
    error:    root.querySelector('[data-r-error]'),
    status:   root.querySelector('[data-r-status]'),
    statusLbl:root.querySelector('[data-r-status-label]'),
    statusVal:root.querySelector('[data-r-status-value]'),
    statusNote:root.querySelector('[data-r-status-note]'),
    figures:  root.querySelector('[data-r-figures]'),
    rows:     root.querySelector('[data-r-rows]'),
    warnings: root.querySelector('[data-r-warnings]')
  };

  var STATUS_CLASSES = ['is-good','is-monitor','is-soon','is-now','is-critical'];

  function field(name) { return root.querySelector('[data-f="' + name + '"]'); }

  function readInput() {
    var o = {};
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') o[f.name] = el.checked;
      else if (f.type === 'number') o[f.name] = parseFloat(el.value);
      else o[f.name] = el.value;
    });
    return o;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function renderFigures(figs) {
    els.figures.innerHTML = (figs || []).map(function (f) {
      return '<div class="pc-tsh__figure">'
        + '<div class="pc-tsh__figure-label">' + esc(f.label) + '</div>'
        + '<div class="pc-tsh__figure-value' + (f.muted ? ' is-muted' : '') + '">'
        + esc(f.value) + '</div>'
        + (f.sub ? '<div class="pc-tsh__figure-sub">' + esc(f.sub) + '</div>' : '')
        + '</div>';
    }).join('');
  }

  function renderRows(rows) {
    if (!els.rows) return;
    els.rows.innerHTML = (rows || []).map(function (r) {
      if (r.head) {
        return '<div class="pc-tsh__row pc-tsh__rows-head">' + esc(r.head) + '</div>';
      }
      return '<div class="pc-tsh__row">'
        + '<span class="pc-tsh__row-label">' + esc(r.label) + '</span>'
        + '<span class="pc-tsh__row-value">' + esc(r.value) + '</span>'
        + '</div>';
    }).join('');
  }

  function clearResult(message) {
    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      els.statusVal.textContent  = 'Waiting for your numbers';
      els.statusNote.textContent = message || '';
    }
    els.figures.innerHTML = '';
    if (els.rows) els.rows.innerHTML = '';
    if (els.warnings) els.warnings.style.display = 'none';
  }

  function render() {
    var input  = readInput();
    var result = compute(input);

    if (!result.ok) {
      els.error.textContent = result.errors[0];
      els.error.classList.add('is-shown');
      clearResult(result.errors[0]);
      return;
    }
    els.error.classList.remove('is-shown');

    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      if (result.status) {
        els.status.classList.add('is-' + result.status.key);
        els.statusVal.textContent  = result.status.label;
        els.statusNote.textContent = result.status.note || '';
      } else {
        els.statusVal.textContent  = '';
        els.statusNote.textContent = '';
      }
    }

    renderFigures(result.figures);
    renderRows(result.rows);

    if (els.warnings) {
      if (result.warnings && result.warnings.length) {
        els.warnings.textContent = result.warnings[0];
        els.warnings.style.display = '';
      } else {
        els.warnings.style.display = 'none';
      }
    }

    writePermalink(input);
  }

  /* ====================================================================
     Shareable result permalinks
     ==================================================================== */
  function writePermalink(input) {
    if (!window.history || !window.history.replaceState) return;
    var q = FIELDS.map(function (f) {
      var v = input[f.name];
      if (f.type === 'checkbox') return v ? f.key + '=1' : '';
      if (v == null || v !== v || v === '') return '';
      return f.key + '=' + encodeURIComponent(v);
    }).filter(Boolean).join('&');
    try {
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  function applyPermalink() {
    if (!window.URLSearchParams) return;
    var p = new URLSearchParams(window.location.search);
    var any = false;
    FIELDS.forEach(function (f) {
      if (!p.has(f.key)) return;
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') el.checked = p.get(f.key) === '1';
      else el.value = p.get(f.key);
      any = true;
    });
    return any;
  }

  /* ====================================================================
     Init
     ==================================================================== */
  ['input', 'change'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (e.target.closest('[data-r-form]')) render();
    });
  });

  applyPermalink();
  render();

  /* Exposed for testing and debugging only. */
  window.PC_TSH = { compute: compute };
})();
